import React, { useState } from 'react';
import { Grid, Box, Button } from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import { fetchCityDispatch } from '../../reducers/HomeReducer';
import {
	setSelectedArrival,
	setSelectedDepart,
} from '../../reducers/UiReducer';
import { DatePicker } from 'antd';
import { Modal } from 'antd';
import { AutoComplete } from 'antd';
import moment from 'moment';
import { AddSearchFlightFDDispatch } from '../../reducers/FDReducer';
import { useNavigate } from 'react-router-dom';
const Option = AutoComplete.Option;

const SearchEngineFD = () => {
	const dispatch = useDispatch();
	const navigate = useNavigate();
	const { city } = useSelector((state) => state.home);
	const [departDate, setDepartDate] = useState('');
	const [open, setOpen] = useState(false);
	const [adult, setAdult] = useState(1);
	const [child, setChild] = useState(0);
	const [loading, setLoading] = useState(false);
	const { depart, arrival } = useSelector((state) => state.ui);
	const [infant, setInfant] = useState(0);
	const handleChange = (value) => {
		let values = value.toLowerCase();
		let cityData = {
			keywords: values,
			limits: 10,
		};
		dispatch(fetchCityDispatch(cityData));
		dispatch(setSelectedDepart(value));
	};
	const handleChange2 = (value) => {
		let values = value.toLowerCase();
		let cityData = {
			keywords: values,
			limits: 10,
		};
		dispatch(fetchCityDispatch(cityData));
		dispatch(setSelectedArrival(value));
	};
	const opsList =
		city?.result?.length > 0 &&
		city.result?.map((l) => {
			return (
				<Option
					value={`${l.airport_code} - ${l.city_name},${l.country_code}`}>{`${l.airport_code} - ${l.city_name} , ${l.country_name}`}</Option>
			);
		});
	const opsList2 =
		city?.result?.length > 0 &&
		city.result?.map((l) => {
			return (
				<Option
					value={`${l.airport_code} - ${l.city_name},${l.country_code}`}
					onChange={() =>
						console.log('a', l)
					}>{`${l.airport_code} - ${l.city_name} , ${l.country_name}`}</Option>
			);
		});
	function disabledDate(current) {
		// Can not select days before today and today
		return current && current < moment().endOf('day');
	}
	const onChange: DatePickerProps['onChange'] = (date, dateString) => {
		console.log('date', dateString);
		setDepartDate(dateString);
	};
	const showModal = () => {
		setOpen(true);
	};
	const handleCancel = () => {
		setOpen(false);
	};
	const handleOk = () => {
		setLoading(true);
		setTimeout(() => {
			setLoading(false);
			setOpen(false);
		}, 3000);
	};
	const handleSubmit = () => {
		let formAIQ = {
			Origin: depart.split(' ')[0],
			Destination: arrival.split(' ')[0],
			DepartureDate: `${departDate.split('-')[0]}/${departDate.split('-')[1]}/${
				departDate.split('-')[2]
			}`,
			AdultCount: adult,
			ChildCount: child,
			InfantCount: infant,
			AirlineCode: '',
			agent_id: 0,
		};
		let formData = {
			AdultCount: adult,
			ChildCount: child,
			InfantCount: infant,
			DirectFlight: false,
			OneStopFlight: false,
			JourneyType: 1,
			PreferredAirlines: null,
			Segments: [
				{
					Origin: depart.split(' ')[0],
					Destination: arrival.split(' ')[0],
					FlightCabinClass: 1,
					PreferredDepartureTime: departDate,
				},
			],
			Sources: 'WEB',
			agent_id: 0,
		};
		navigate('/searchresultpromo', { state: formData });
		dispatch(AddSearchFlightFDDispatch(formData, formAIQ));
	};
	return (
		<Grid container spacing={1}>
			<Grid item xs={12} sm={12} md={3} lg={3}>
				<AutoComplete
					style={{ width: '100%' }}
					dropdownMenuStyle={{
						maxHeight: 1000,
						overflowY: 'visible',
					}}
					placeholder='From'
					onClick={(e) => console.log('val', e.target.value)}
					onChange={handleChange}>
					{opsList}
				</AutoComplete>
			</Grid>
			<Grid item xs={12} sm={12} md={3} lg={3}>
				<AutoComplete
					style={{ width: '100%' }}
					dropdownMenuStyle={{
						maxHeight: 1000,
						overflowY: 'visible',
					}}
					placeholder='To'
					onChange={handleChange2}>
					{opsList2}
				</AutoComplete>
			</Grid>
			<Grid item xs={12} sm={12} md={3} lg={2}>
				<DatePicker
					disabledDate={disabledDate}
					onChange={onChange}
					style={{ width: '100%', padding: 8 }}
				/>
			</Grid>
			<Grid item xs={12} sm={12} md={3} lg={2}>
				<Button
					onClick={showModal}
					style={{
						textTransform: 'capitalize',
						padding: 7,
						border: '1px solid lightgrey',
						width: '100%',
					}}>
					Traveller Class
				</Button>{' '}
				<Modal
					open={open}
					title='Travellers'
					onOk={handleOk}
					onCancel={handleCancel}
					footer={[
						<Button key='back' onClick={handleCancel}>
							OK
						</Button>,
					]}>
					<Box
						style={{
							display: 'flex',
							justifyContent: 'space-between',
						}}>
						<p>Adults(12+yrs)</p>
						<Box>
							<Button
								onClick={() => (adult === 0 ? '' : setAdult(adult - 1))}
								style={{
									fontSize: 14,
									background: 'orange',
									color: 'white',
								}}>
								--
							</Button>
							<Button
								style={{
									fontSize: 14,
									background: 'white',
								}}>
								{adult}
							</Button>
							<Button
								onClick={() =>
									adult + child + infant === 9 ? adult : setAdult(adult + 1)
								}
								style={{
									fontSize: 14,
									background: 'orange',
									color: 'white',
								}}>
								+
							</Button>
						</Box>
					</Box>
					<Box
						style={{
							display: 'flex',
							justifyContent: 'space-between',
						}}>
						<p>Child(2-11yrs)</p>
						<Box>
							<Button
								onClick={() => (child === 0 ? '' : setChild(child - 1))}
								style={{
									fontSize: 14,
									background: 'orange',
									color: 'white',
								}}>
								--
							</Button>
							<Button
								style={{
									fontSize: 14,
									background: 'white',
								}}>
								{child}
							</Button>
							<Button
								onClick={() =>
									adult + child + infant === 9 ? child : setChild(child + 1)
								}
								style={{
									fontSize: 14,
									background: 'orange',
									color: 'white',
								}}>
								+
							</Button>
						</Box>
					</Box>
					<Box
						style={{
							display: 'flex',
							justifyContent: 'space-between',
						}}>
						<p>Infant(0-2yrs)</p>
						<Box>
							<Button
								onClick={() => (infant === 0 ? '' : setInfant(infant - 1))}
								style={{
									fontSize: 14,
									background: 'orange',
									color: 'white',
								}}>
								--
							</Button>
							<Button
								style={{
									fontSize: 14,
									background: 'white',
								}}>
								{infant}
							</Button>
							<Button
								onClick={() =>
									adult + child + infant === 9 ? infant : setInfant(infant + 1)
								}
								style={{
									fontSize: 14,
									background: 'orange',
									color: 'white',
								}}>
								+
							</Button>
						</Box>
					</Box>
				</Modal>
			</Grid>
			<Grid item xs={12} sm={12} md={3} lg={2}>
				<Button
					onClick={handleSubmit}
					variant='contained'
					style={{
						width: '100%',
						background: 'orange',
						fontWeight: 'bold',
						padding: '7px',
					}}>
					Search
				</Button>
			</Grid>
		</Grid>
	);
};

export default SearchEngineFD;
